import React, { Component, useRef } from "react";
import "../../Reports/TimesheetReport.css";
import html2canvas from "html2canvas";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import { jsPDF } from "jspdf";
import dayjs from "dayjs";
import QRCode from "qrcode.react";

export default class TimesheetDocument extends Component {
  constructor(props) {
    super(props);
    this.elHeight = document.getElementById("A4");
    var today = new Date(),
      date =
        today.getDate() +
        "." +
        (today.getMonth().length < 8 ? "0" : "") +
        (today.getMonth() + 1) +
        "." +
        today.getFullYear();
    this.state = {
      currentDate: date,
      heightA4: 0,
    };
  }

  printDocument() {
    const input = document.getElementById("A4");
    html2canvas(input, {
      scale: 3,
    }).then((canvas) => {
      const name = "Timesheet.pdf";
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "landscape",
        dpi: 100,
        format: "A4",
      });
      pdf.addImage(imgData, "JPEG", 0, 0, 297, 210);
      // pdf.output('dataurlnewwindow');
      pdf.save(name);
    });
  }

  OpenSelectorOptions(options, option_name) {
    this.props.OpenSelectorOptions(options, option_name);
  }
  ApprovedRepor = (approved, id_timesheetMovement, timesheet_number) => {
    this.props.postApproveReport(
      approved,
      id_timesheetMovement,
      timesheet_number
    );
  };

  render() {
    const { DimDate, TimesheetPPS, Type_day, TimesheetMovement, GlavaVuza } =
      this.props;
    return (
      <div className="TimesheetReport">
        <div className="ReportModalButtonWrapper">
          <ReactToPrint content={() => this.componentRef}>
            <PrintContextConsumer>
              {({ handlePrint }) => (
                <button onClick={handlePrint} title="Печать">
                  <i className="fa fa-print"></i>
                  Печать
                </button>
              )}
            </PrintContextConsumer>
          </ReactToPrint>
          <button title="Сохранить" onClick={this.printDocument}>
            <i className="far fa-file-pdf"></i>
            Сохранить
          </button>
        </div>
        {TimesheetPPS && TimesheetPPS.length ? (
          <div ref={(el) => (this.componentRef = el)} id="A4">
            {/* <div className="Utverjdaiu">
              <h4>Утверждаю</h4>
              <p>{GlavaVuza && GlavaVuza.length ? GlavaVuza[0].v3 : null}</p>
              <p style={{ display: "flex", gap: "10px" }}>
                {TimesheetMovement?.length &&
                TimesheetMovement.filter((a) => a.glava == true).length
                  ? TimesheetMovement.filter((a) => a.glava == true).map(
                      (m) => m.t_fio
                    )
                  : "__________________________"}
              </p>
              <p>
                {TimesheetMovement && TimesheetMovement.length
                  ? TimesheetMovement.filter((a) => a.glava == true).map((m) =>
                      m.approved > 0 ? (
                        <div className="QR">
                          <QRCode
                            id="qrCodeEl"
                            value={`${m.timesheet_number}-${dayjs(
                              m.approved_dates
                            ).format("YYYY-MM-DD")}-${m.id_avn_login}`}
                          />
                          __________________
                        </div>
                      ) : null
                    )
                  : null}
              </p>
            </div> */}
            <h3 className="Title">ТАБЕЛЬ УЧЕТА РАБОЧЕГО ВРЕМЕНИ</h3>
            <h4 className="under_Title">
              {" "}
              {this.props.statuss === 0 ? "Кафедра" : "Отдел"} "
              {this.props.kafedra_otdel}" за{" "}
              <span>{this.props.months?.toLowerCase()}</span> {this.props.year}{" "}
              г.
            </h4>
            <div className="table_container">
              <table>
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Ф.И.О.</th>
                    <th>Должность</th>
                    <th>ИНН</th>
                    <th style={{ width: "40px" }}>Б</th>
                    <th style={{ width: "40px" }}>К</th>
                    {DimDate &&
                      DimDate.length &&
                      DimDate.map((item, index) => {
                        return (
                          <th
                            key={"DimDate" + index}
                            style={{ maxWidth: "20px", padding: "0" }}
                            className={item.Day_off == 1 ? "Weekend " : null}
                          >
                            {item.DayOfWeekName == "понедельник" ? (
                              <p>Пн</p>
                            ) : null}
                            {item.DayOfWeekName == "вторник" ? <p>Вт</p> : null}
                            {item.DayOfWeekName == "среда" ? <p>Ср</p> : null}
                            {item.DayOfWeekName == "четверг" ? <p>Чт</p> : null}
                            {item.DayOfWeekName == "пятница" ? <p>Пт</p> : null}
                            {item.DayOfWeekName == "суббота" ? <p>Сб</p> : null}
                            {item.DayOfWeekName == "воскресенье" ? (
                              <p>Вс</p>
                            ) : null}
                            {item.DayDate}
                          </th>
                        );
                      })}
                    <th style={{ width: 35 }}>
                      <div className="rotate">
                        <p>Всего дней</p>
                      </div>{" "}
                    </th>
                    {/* <th>
                      <div className="rotate">
                        <p>Больнич. лист</p>
                      </div>
                    </th>
                    <th>
                      <div className="rotate">
                        <p>Командировка</p>
                      </div>
                    </th>
                    <th>
                      <div className="rotate">
                        <p>Трудовой отпуск</p>
                      </div>
                    </th>
                    <th>
                      <div className="rotate">
                        <p>Прогул</p>
                      </div>
                    </th> */}
                  </tr>
                </thead>
                <tbody>
                  {TimesheetPPS && TimesheetPPS.length
                    ? TimesheetPPS.map((timesheet, timesheet_ind) => {
                        return (
                          <tr key={"timesheet" + timesheet_ind}>
                            <td>{timesheet_ind + 1}</td>
                            <td
                              style={{ textAlign: "left", minWidth: "100px" }}
                            >
                              {timesheet.s_t_fio}
                            </td>
                            <td>{timesheet.post}</td>
                            <td>{timesheet.INN}</td>
                            <td>{timesheet.b_stavka}</td>
                            <td>{timesheet.k_stavka}</td>
                            {timesheet.arr.map((item, index) => {
                              return (
                                <td
                                  key={"DimDate" + index}
                                  className={
                                    item.id_type_day == 1 ? "Weekend " : null
                                  }
                                  style={{
                                    padding: "0",
                                    fontWeight:
                                      item.id_type_day > 0 ? "600" : "400",
                                    width: "30px",
                                  }}
                                >
                                  {item.yacheyka}
                                </td>
                              );
                            })}
                            <td style={{ fontWeight: 600 }}>
                              {timesheet.work}
                            </td>
                            {/* <td>{timesheet.b > 0 ? timesheet.b : null}</td>
                            <td>{timesheet.k > 0 ? timesheet.k : null}</td>
                            <td>{timesheet.ot > 0 ? timesheet.ot : null}</td>
                            <td>{timesheet.p > 0 ? timesheet.p : null}</td> */}
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
              {this.state.dayTypeSelector == true ? (
                <div>
                  <div className="Teacher_list_Nav">
                    <div className="Teacher_list_Nav_header">
                      <h3>Выберите тип дня</h3>
                      <i
                        className="fas fa-times"
                        onClick={() =>
                          this.selectDay_type(
                            this.state.id_type_day,
                            this.state.type_work
                          )
                        }
                      ></i>
                    </div>
                    {Type_day && Type_day.length ? (
                      Type_day.map((item, index) => {
                        return (
                          <li
                            onClick={() =>
                              this.selectDay_type(
                                item.id_type_day,
                                item.type_work
                              )
                            }
                            key={"type_day" + index}
                          >
                            <p>{item.id_type_day > 0 && item.id_type_day}</p>
                            <p>{item.id_type_day > 0 && item.type_day}</p>
                          </li>
                        );
                      })
                    ) : (
                      <li>
                        <p></p>
                        <p>нет данных</p>
                      </li>
                    )}
                  </div>
                </div>
              ) : null}
            </div>
            <div className="A4_Footer">
              {TimesheetMovement && TimesheetMovement.length
                ? TimesheetMovement.filter((a) => a.glava == false).map(
                    (m, i) => {
                      return (
                        <div key={"post" + { i }}>
                          <p>{m.timesheet_post}:</p>
                          <h4>{m.t_fio}</h4>
                          {
                            <nav className="container">
                              {" "}
                              {m.approved > 0 ? (
                                <div className="QR">
                                  <QRCode
                                    id="qrCodeEl"
                                    value={`${m.timesheet_number}-${dayjs(
                                      m.approved_dates
                                    ).format("YYYY-MM-DD")}-${m.id_avn_login}`}
                                  />
                                  __________________
                                </div>
                              ) : null}
                            </nav>
                          }
                        </div>
                      );
                    }
                  )
                : null}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
